var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgDish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.822,
    height: 54.822,
    viewBox: "0 0 54.822 54.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.502;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.24 13.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M265.593,124.732l-.587-1.931a4.194,4.194,0,0,0-7.942,0l-.587,1.931a10.844,10.844,0,0,0-.3,5.025,4.727,4.727,0,0,0,2.434,3.294l-.657,14.686a2.894,2.894,0,0,0,.731,2.25,3.192,3.192,0,0,0,4.509.2q.106-.1.2-.2a2.855,2.855,0,0,0,.731-2.188l-.661-14.749a4.726,4.726,0,0,0,2.43-3.292A10.845,10.845,0,0,0,265.593,124.732Zm-1.5,4.707a2.9,2.9,0,0,1-1.9,2.183.914.914,0,0,0-.591.9l.694,15.424a1.057,1.057,0,0,1-.274.828,1.412,1.412,0,0,1-1.986,0,1.1,1.1,0,0,1-.269-.888l.689-15.364a.914.914,0,0,0-.591-.9,2.9,2.9,0,0,1-1.9-2.183,9.01,9.01,0,0,1,.251-4.172l.587-1.932a2.369,2.369,0,0,1,4.444,0l.587,1.932A9.022,9.022,0,0,1,264.1,129.439Z",
    transform: "translate(-256.012 -119.955)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.533 13.706)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M145.137,120a.914.914,0,0,0-.914.914v7.845l-2.473,2.473a.914.914,0,0,0-.268.692l.8,15.99a1.245,1.245,0,0,1-.345.931,1.287,1.287,0,0,1-1.819.008l-.008-.008a1.244,1.244,0,0,1-.345-.931l.8-15.99a.914.914,0,0,0-.267-.692l-2.474-2.473v-7.845a.914.914,0,1,0-1.827,0v8.223a.913.913,0,0,0,.268.646l2.454,2.455-.779,15.587a3.086,3.086,0,0,0,6.166.3q.007-.15,0-.3l-.779-15.587,2.454-2.455a.914.914,0,0,0,.268-.646v-8.223A.914.914,0,0,0,145.137,120Z",
    transform: "translate(-136 -120)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.274 13.706)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M160.914,120a.914.914,0,0,0-.914.914v7.31a.914.914,0,0,0,1.827,0v-7.31A.914.914,0,0,0,160.914,120Z",
    transform: "translate(-160 -120)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.015 13.706)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M184.914,120a.914.914,0,0,0-.914.914v7.31a.914.914,0,0,0,1.827,0v-7.31A.914.914,0,0,0,184.914,120Z",
    transform: "translate(-184 -120)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.411,0A27.411,27.411,0,1,0,54.822,27.411,27.411,27.411,0,0,0,27.411,0Zm0,52.995A25.584,25.584,0,1,1,52.995,27.411,25.584,25.584,0,0,1,27.411,52.995Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.454 43.738)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M220.035,383.774a.914.914,0,0,0-1-.821l-.035,0h0a16.778,16.778,0,0,1-3.872,0,.914.914,0,0,0-.213,1.816,18.509,18.509,0,0,0,4.294,0A.914.914,0,0,0,220.035,383.774Z",
    transform: "translate(-214.113 -382.949)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.752 15.311)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M341.934,134.379a.914.914,0,0,0-1.287-.113l0,0a.914.914,0,0,0-.11,1.287,16.447,16.447,0,0,1-.969,22.246.914.914,0,1,0,1.29,1.295A18.274,18.274,0,0,0,341.934,134.379Z",
    transform: "translate(-339.295 -134.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.374 9.14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M186.357,105.743h0Z",
    transform: "translate(-185.442 -102.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M189.729,80.535a18.436,18.436,0,0,0-10.755.661.913.913,0,1,0,.641,1.71,16.6,16.6,0,0,1,9.685-.594.914.914,0,1,0,.429-1.776Z",
    transform: "translate(-178.382 -80.027)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.136 16.274)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M86.613,165.229a16.445,16.445,0,0,1-1.652-21.278.914.914,0,0,0-1.461-1.1l-.016.022a18.274,18.274,0,0,0,1.834,23.648.915.915,0,1,0,1.295-1.294Z",
    transform: "translate(-79.989 -142.488)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDish);
export default __webpack_public_path__ + "static/media/dish.54e4ef57e9385a621a885ba90b569265.svg";
export { ForwardRef as ReactComponent };